<script setup lang="ts">
import { BBtn, BIcon } from '@/design-system';

type Props = {
    icon?: string;
    iconSize?: string;
};

const props = withDefaults(defineProps<Props>(), {
    icon: 'mdi-close',
    iconSize: '20',
});
</script>

<template>
    <BBtn
        size="x-small"
        class="v-dialog-close-btn"
    >
        <BIcon
            :icon="props.icon"
            :size="props.iconSize"
        />
    </BBtn>
</template>

<style scoped lang="scss">
.v-dialog-close-btn {
    --clr-box-shadow: 47, 43, 61, 0.14;
    position: absolute;
    z-index: 1;
    color: rgba(var(--v-theme-on-surface), var(--v-disabled-opacity)) !important;
    background-color: rgb(var(--v-theme-surface)) !important;
    block-size: 2rem;
    inline-size: 2rem;
    inset-block-start: 0;
    inset-inline-end: 0;
    transform: translate(-0.5rem, 0.5rem);
    box-shadow: none;

    &:hover {
        transform: translate(0.3125rem, -0.3125rem);
    }

    .v-btn__overlay {
        display: none;
    }

    @media screen and (min-width: 600px) {
        position: absolute;
        box-shadow:
            0 2px 6px rgba(var(--clr-box-shadow)),
            0 0 transparent,
            0 0 transparent !important;
        transform: translate(0.5rem, -0.5rem);
    }
}
</style>
